import { Alert, Button, Paper, Divider, TextInput, Group, Text, Title, Stack } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Head from "../../components/common/Head";
import UsersTable from "../../components/users/UsersTable";
import { disableUsers, getAllUsers } from "../../utils/api";
import useStore from "../../utils/store";


const EnabledUsers = () => {
  const user = useStore((state) => state.user);
  const [users, setUsers] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState("");

  const [current, setCurrent] = useState(
    parseInt(searchParams.get("page") || "1")
  );
  const [limit, setLimit] = useState(10);

  const reset = async () => {
    setLoading(true);
    const [success, response] = await getAllUsers(1, limit, searchQuery);
    if (success) {
      setUsers(response);
      setCurrent(1);
      setSearchParams({ page: "1" });
    }
    setLoading(false);
  };

  const getAllUserData = async (page, newLimit) => {
    const limitToUse = newLimit !== undefined && newLimit !== null ? newLimit : limit;
    setLoading(true);
    const [success, response] = await getAllUsers(page, limitToUse, searchQuery);

    if (success) {
      setUsers(response);
    }
    setLoading(false);
  };

  const handleDisableUsers = async () => {
    const [success] = await disableUsers({ userIds: selectedUsers });
    if (success) {
      notifications.show({ message: "Users disabled successfully", color: "green" });
      setSelectedUsers([]);
      getAllUserData(current);
    } else {
      notifications.show({ message: "Failed to disable users", color: "red" });
    }
  };

  const handlePaginationChange = (page) => {
    setCurrent(page);
    setSearchParams({
      page: page.toString(),
    });
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    setCurrent(1);
    getAllUserData(1);
  };

  React.useEffect(() => {
    getAllUserData(current);
  }, [current, limit]);

  return user?.getAllUsers ? (
    <div
      style={{
        padding: "24px",
        minHeight: "100vh",
      }}
    >
      
      <Head
        title="Enabled Users"
        customButton={
          user?.addUser ? (
            <Link to={`/users/add`}>
              <Button size="large">
                Add New User
              </Button>
            </Link>
          ) : null
        }
      />

      <Paper withBorder p="md"
        style={{
          marginTop: "24px",
          backgroundColor: "#1f1f1f",
          borderColor: "#303030",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        }}
      >
        <Stack gap="lg" style={{ width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Title order={2} style={{ color: "#fff", margin: 0 }}>
              User Management
            </Title>
            <div style={{ width: "400px", display: "flex", gap: 8 }}>
              <TextInput
                placeholder="Search users by name, email, or phone..."
                size="md"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSearch(searchQuery)}
                styles={{
                  input: {
                    backgroundColor: "#141414",
                    color: "#fff",
                    borderColor: "#303030",
                  },
                }}
                style={{ flex: 1 }}
              />
              <Button onClick={() => handleSearch(searchQuery)}>Search</Button>
            </div>
          </div>

          <Divider style={{ borderColor: "#303030", margin: "16px 0" }} />

          <UsersTable
            users={users}
            loading={loading}
            getAllUserData={getAllUserData}
            type="enabled"
            selectedUsers={selectedUsers}
            setSelectedUsers={setSelectedUsers}
            onDisableUsers={handleDisableUsers}
            current={current}
            setCurrent={handlePaginationChange}
            limit={limit}
            setLimit={setLimit}
            currentPage={current}
          />
        </Stack>
      </Paper>
    </div>
  ) : (
    <div className="flex justify-center items-center h-screen">
      <Alert
        title="You are not authorized to access this page"
        color="red"
      />
    </div>
  );
};

export default EnabledUsers;
